import type { LegacyMetricsSummary } from "./legacyMetrics.types";
import { makeLegacyMetricsSummary } from "./legacyMetrics.fixtures";

/**
 * Data access for Legacy Metrics.
 *
 * TODAY: resolves the Figma sample summary (`isSample: true`, shown as "Sample
 * data"). customer-portal-api's only Legacy Metrics endpoint so far,
 * `GET /api/legacy-metrics/api-usage`, is per partner and feeds none of these
 * portfolio tiles.
 * TODO: once each tile's data source is agreed, fetch from the matching
 * `/api/legacy-metrics/...` endpoint (each enforces `metrics.legacy.read`) and
 * add `Raw*` wire types with a `toLegacyMetricsSummary()` mapper here.
 */
export function fetchLegacyMetricsSummary(): Promise<LegacyMetricsSummary> {
  return Promise.resolve(makeLegacyMetricsSummary());
}
